import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import BryxColors from "../types/theme";
import BryxBox from "./BryxBox";
import BryxIcon from "./BryxIcon/BryxIcon";
const supportedAttachmentFiles = ["PDF", "TXT", "DOC", "DOCX"];
const isFileType = (val) => supportedAttachmentFiles.includes(val);
const CloseButton = styled((props) => _jsx(BryxIcon, { ...props, iconName: "close", smIconSize: true }))(({ theme }) => {
    const palette = theme.palette.mode;
    return {
        color: BryxColors.notify(palette, "inactive"),
        width: "14px",
        height: "14px",
        marginLeft: "auto",
        marginBottom: "14px",
        alignSelf: "center",
        ":hover": {
            color: BryxColors.brandPrimary(palette),
            height: "20px",
            width: "20px",
            transform: "translate(2px)",
        },
    };
});
const Container = styled("div", {
    shouldForwardProp: (prop) => prop !== "isExpanded",
})(({ isExpanded, theme }) => {
    const palette = theme.palette.mode;
    return {
        padding: "10px 0px",
        maxWidth: isExpanded ? "319px" : "291px",
        ":hover": {
            "& .MuiTypography-root": {
                color: !isExpanded ? `${BryxColors.brand1(palette)}` : "",
                ".MuiTypography-body1": {
                    fontWeight: 700,
                },
            },
            "& .MuiSvgIcon-root": {
                color: !isExpanded ? `${BryxColors.brand1(palette)}` : "",
            },
        },
    };
});
const AttachmentTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "isExpanded",
})(({ isExpanded, variant, theme }) => {
    const palette = theme.palette.mode;
    return {
        paddingLeft: isExpanded ? "0px" : "48px",
        transition: "padding-left 0.5s, padding-bottom 0.5s",
        paddingBottom: isExpanded && variant == "body1" ? "16px" : "0px",
        paddingTop: isExpanded && variant == "caption" ? "16px" : "0px",
        fontWeight: variant == "body1" ? 600 : 400,
        color: variant == "body1" ? BryxColors.brandDark2(palette) : BryxColors.notify(palette, "inactive"),
    };
});
const AttachmentContainer = styled("div", {
    shouldForwardProp: (prop) => prop !== "isExpanded",
})(({ isExpanded, theme }) => {
    return {
        height: isExpanded ? "216px" : "0px",
        overflow: "visible",
        transition: "height 0.5s, transform 0.5s",
        transform: isExpanded ? "translate(0px, 0px)" : "translate(0px, -20px)",
    };
});
const BryxAttachment = (props) => {
    const [expanded, setExpanded] = useState(false);
    const [openFullScreen, setOpenFullScreen] = useState(false);
    const handleImageExpand = () => {
        setExpanded(!expanded);
    };
    const handleFileClick = () => {
        setOpenFullScreen(true);
    };
    const handleFullScreen = (e) => {
        e.stopPropagation();
        setOpenFullScreen(true);
    };
    const handleClose = () => {
        setOpenFullScreen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Container, { onClick: !isFileType(props.attachmentType) ? handleImageExpand : handleFileClick, isExpanded: expanded, children: _jsxs(BryxBox, { isFlex: true, fullHeight: true, fullWidth: true, sx: { flexDirection: "column" }, children: [_jsxs(BryxBox, { isFlex: true, fullHeight: true, fullWidth: true, children: [_jsx(AttachmentTypography, { variant: "body1", fontSize: 16, isExpanded: expanded, children: props.name }), expanded ? _jsx(CloseButton, {}) : _jsx(_Fragment, {})] }), _jsx(AttachmentContainer, { isExpanded: expanded, children: !isFileType(props.attachmentType) ? (_jsx("img", { onClick: expanded ? handleFullScreen : undefined, height: expanded ? 216 : 40, width: expanded ? 319 : 40, src: props.src, style: { transition: "width 0.5s, height 0.5s", borderRadius: "4px" } })) : (_jsx(BryxIcon, { iconName: "document", lgIconSize: true, sx: { height: "40px !important", width: "40px !important" } })) }), _jsx(AttachmentTypography, { variant: "caption", fontSize: 10, noWrap: true, isExpanded: expanded, children: props.caption })] }) }), _jsx(Dialog, { fullWidth: true, maxWidth: "xl", open: openFullScreen, onClose: handleClose, sx: {
                    "& .MuiBackdrop-root": { backgroundColor: "#230808", opacity: "50% !important" },
                    "& .MuiDialog-paper": { height: isFileType(props.attachmentType) ? "85%" : "auto" },
                }, children: _jsx(DialogContent, { onClick: handleClose, sx: { overflow: "hidden", padding: 0 }, children: !isFileType(props.attachmentType) ? (_jsx("img", { style: { display: "block" }, height: "100%", width: "100%", src: props.src })) : (_jsx("iframe", { height: "100%", width: "100%", src: props.src })) }) })] }));
};
export default BryxAttachment;
